export const SESSION_MARKER = 'cookie-session';
const CSRF_COOKIE = '__Host-simvox-pilot-csrf';
let pendingSession;
export function csrfToken() {
  const prefix = `${CSRF_COOKIE}=`;
  const value = document.cookie.split(';').map(part => part.trim()).find(part => part.startsWith(prefix));
  return value ? decodeURIComponent(value.slice(prefix.length)) : '';
}
export function clearSessionState() {
  for (const name of ['jwt_token', 'user', 'userVerifyData', 'tkutim']) localStorage.removeItem(name);
  sessionStorage.removeItem('user');
}
export async function readSession() {
  if (!pendingSession) pendingSession = fetch('/pilot-api/session', { credentials: 'same-origin', cache: 'no-store' })
    .then(async response => {
      if (!response.ok) throw new Error('The sign-in service is unavailable');
      const session = await response.json();
      if (session.authenticated) localStorage.setItem('jwt_token', SESSION_MARKER);
      else clearSessionState();
      return session;
    }).finally(() => { pendingSession = null; });
  return pendingSession;
}
export async function ensureCsrf() {
  if (!csrfToken()) await readSession();
  const token = csrfToken();
  if (!token) throw new Error('Refresh this page to verify your session');
  return token;
}
